/**
 * 判断当前设备是否为移动端
 * @returns {boolean} 是否为移动端设备
 */
export function isMobile(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const userAgent = window.navigator.userAgent.toLowerCase();
  const mobileRegex = /mobile|android|iphone|ipad|ipod|blackberry|windows phone|iemobile|opera mini/i;
  const isMobile = mobileRegex.test(userAgent);
  console.log('isMobile:', isMobile);
  return isMobile;
}
